import React, { useEffect, useState } from 'react';
import FileUpload from './components/FileUpload';
import HeaderBar from './components/HeaderBar';
import MyFiles from './components/MyFiles';
import UploadIcon from '@mui/icons-material/Upload';
import GoogleSignIn from './GoogleSignIn';
import { auth, provider } from './firebase';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';  // Import routing components
import { v4 as uuidv4 } from 'uuid';

function App() {
    const [file, setFile] = useState(null);
    const [user, setUser] = useState(null);  // Holds signed-in user or guest user info
    const handleFileSelect = (uploadedFile) => { setFile(uploadedFile); };
    const handleSignIn = (userData) => { setUser(userData); };

    // Add global state for uploads
    const [uploadState, setUploadState] = useState(null);


    

    // Guest Token Management
    const verifyOrGetGuestToken = async () => {
        const storedToken = localStorage.getItem('token');
        const storedGuestId = localStorage.getItem('guestId'); // Retrieve stored guest ID

        if (storedToken) {
            try {
                const decoded = jwtDecode(storedToken);
                const now = Date.now() / 1000;
                if (decoded.exp > now) {
                    decoded.guestId = storedGuestId || decoded.guestId; // Use stored guest ID if available
                    localStorage.setItem('guestId', decoded.guestId); // Persist guest ID
                    return storedToken;
                }
            } catch (e) {
                console.error('Invalid token:', e);
            }
        }

        try {
            const response = await axios.post('/app/guest-token');
            const newToken = response.data.token;
            const decoded = jwtDecode(newToken);
            localStorage.setItem('token', newToken);
            localStorage.setItem('guestId', decoded.guestId); // Store guest ID
            return newToken;
        } catch (error) {
            console.error('Error getting guest token:', error);
            return null;
        }
    };

    // Auth State Listener
    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(async (loggedInUser) => {
            if (loggedInUser) {
                const token = await verifyOrGetGuestToken();
                const decodedToken = jwtDecode(token);

                const { displayName, email, photoURL } = loggedInUser;

                try {
                    const response = await axios.post('/app/user-info', {
                        displayName,
                        email,
                        photoURL,
                        guestId: decodedToken.guestId || localStorage.getItem('guestId')
                    });

                    if (response.data.token) {
                        localStorage.setItem('token', response.data.token);
                    }

                    setUser({ ...decodedToken, displayName, email, photoURL });
                } catch (error) {
                    console.error('Error syncing user data:', error);
                }
            } else {
                // Guest flow
                const guestToken = await verifyOrGetGuestToken();
                setUser(jwtDecode(guestToken));
            }
        });

        return () => unsubscribe();
    }, []);




    // Checks if an existing token is valid. If not, triggers guest login.
    const verifyOrGetGuestToken_working = async () => {
        const storedToken = localStorage.getItem('token');
        console.log('storedToken: ', storedToken);
        /*if (storedToken) {
            try {
                const decoded = jwtDecode(storedToken);
                const now = Date.now() / 1000;
                if (decoded.exp > now) {
                    // Token is valid. Mark this as a guest if needed.
                    const guestUser = { ...decoded, isGuest: true };
                    setUser(guestUser);
                    console.log('Using valid stored token:', storedToken);
                    return;
                } else {
                    console.log('Stored token has expired.');
                }
            } catch (e) {
                console.error('Error decoding stored token:', e);
            }
        }
        */
        // No token or invalid/expired, so perform guest login.
        try {
            console.log(`Sending stored token: '${storedToken}'`);
            const response = await axios.post('/app/user-info', storedToken ? { token: storedToken } : {}, { headers: storedToken ? { 'Content-Type': 'application/json' } : undefined });
            const guestToken = response.data.token;
            localStorage.setItem('token', guestToken);
            const decodedGuest = jwtDecode(guestToken);
            // Mark as guest explicitly.
            const guestUser = { ...decodedGuest, isGuest: true };
            setUser(guestUser);
            console.log('Obtained new guest token:', guestToken);
        } catch (error) {
            console.error('Error during guest login:', error);
        }
    };


    // Pass state to FileUpload
    <FileUpload
        uploadState={uploadState}
        setUploadState={setUploadState}
    />




    console.log("Auth:", auth);
    console.log("provider:", provider);

    /*us1eEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(async (loggedInUser) => {
            if (loggedInUser) {
                // User is signed in.
                setUser(loggedInUser);
                const token = localStorage.getItem('token');
                if (token) {
                    try {
                        const decodedToken = jwtDecode(token);
                        const now = Date.now() / 1000;
                        if (decodedToken.exp > now) {
                            console.log('Token is valid');
                        } else {
                            console.log('Token has expired');
                        }
                    } catch (e) {
                        console.error('Error decoding token:', e);
                    }
                }
                const { displayName, email, photoURL } = loggedInUser;
                try {
                    const response = await axios.post('/app/user-info', { displayName, email, photoURL, loggedInUser });
                    localStorage.setItem('token', response.data.token);
                    console.log('Token received from user-info:', response.data.token);
                } catch (error) {
                    console.error('Error sending user data to backend:', error);
                }
            } else {
                // No signed-in user: verify existing token or get a new guest token.
                await verifyOrGetGuestToken();
            }
        });


        return () => unsubscribe();
    }, []);*/

    const handleLogout = async () => {
        try {
            await auth.signOut();
            setUser(null);
            localStorage.removeItem('token');
        } catch (error) {
            console.error('Error signing out:', error);
        }
    };

    return (
        <Router>  {/* Wrap the app with BrowserRouter */}
            <HeaderBar user={user} handleLogout={handleLogout} />
            <Routes>  {/* Define routes for different components */}
                <Route path="/" element={
                    <div className="App">
                        <div className="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8">
                            <div className="sm:mx-auto sm:w-full sm:max-w-sm">
                                <img className="invisible mx-auto h-10 w-auto" src="https://tailwindui.com/plus/img/logos/mark.svg?color=indigo&shade=600" alt="Your Company" />
                                <h2 className="invisible mt-10 text-center text-2xl/9 font-bold tracking-tight text-gray-900">Video Converter 0.35</h2>
                            </div>
                            <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
                                {/* Show GoogleSignIn if user is null or if user is a guest */}
                                {(!user || (user && user.isGuest)) ? (
                                    <GoogleSignIn onSignIn={handleSignIn} />
                                ) : (
                                    <>{/*<HeaderBar user={user} handleLogout={handleLogout} />*/}</>
                                )}
                                <FileUpload />
                                {file && (
                                    <div>
                                        <h2>Selected File Details</h2>
                                        <p>Name: {file.name}</p>
                                        <p>Size: {(file.size / 1024 / 1024).toFixed(2)} MB</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                } />
                <Route path="/my-files" element={<MyFiles />} />  {/* Add route for MyFiles */}
            </Routes>
        </Router>
    );
}

export default App;


